import { useCallback } from 'react';
import { useUserContext } from '../providers';
export const useActions = () => {
    const { hasPermissions, user, isDeveloper } = useUserContext();
    const checkAction = useCallback((item) => {
        return item.devOnly
            ? isDeveloper()
            : hasPermissions(() => ({ permissions: item.permissions }));
    }, [hasPermissions, user, isDeveloper]);
    const filterActions = useCallback((items) => {
        return items.filter((item) => checkAction(item));
    }, [checkAction, user]);
    const filterNested = useCallback((items) => {
        return items
            .map((item) => {
            switch (item.type) {
                case 'popover':
                    const filteredChildren = filterNested(item.children);
                    return filteredChildren.length > 0
                        ? { ...item, children: filteredChildren }
                        : null;
                case 'button':
                case 'link':
                    return checkAction(item) ? item : null;
            }
        })
            .filter((item) => !!item);
    }, [filterActions, user]);
    return {
        checkAction,
        filterActions,
        filterNested,
    };
};
